type TValidator = (val: unknown) => string | boolean | null;

/**
 * Пайп для составления набора валидаторов
 * Отдельный валидатор в случае ошибки должен вернуть либо true, либо строковую ошибку
 * */
export const validatorsPipe = (validators: [TValidator, string][]) => (val: unknown) => {
  for (let i = 0; i < validators.length; i++) {
    const [validator, errorMessage] = validators[i];

    const res = validator(val);

    if (res) {
      return typeof res === 'string' ? res : errorMessage;
    }
  }

  return null;
};
